import { useState, useEffect } from 'react';
import { Box, TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { axiosGetCall } from 'src/services/apisCall';
import { PaginationTable } from 'src/components/tables/paginationTable';

const columns = [
  { id: 'domain', label: 'Domain', minWidth: 150, align: 'center' },
  { id: 'success_redirect_url', label: 'Success Redirect URL', minWidth: 200, align: 'center' },
  { id: 'failure_redirect_url', label: 'Failure Redirect URL', minWidth: 200, align: 'center' },
  { id: 'token', label: 'Token', minWidth: 150, align: 'center' },
];

export const ConsoleAuthListSection = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState(true);
  const [networkError, setNetworkError] = useState(false);

  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const fetchData = async () => {
    try {
      setLoading(true);
      const skip = rowsPerPage * page;
      const params = { skip, limit: rowsPerPage };

      if (searchQuery) {
        params.domain = searchQuery;
      }

      const res = await axiosGetCall('fetchConsoleAuthData', params);
      setRows(res.data);
      setCount(res.total);
      setNetworkError(false);
    } catch (err) {
      console.error(err);
      setNetworkError(true);
      setRows([]);
      setCount(0);
    } finally {
      setLoading(false);
      setLoad(false);
    }
  };

  useEffect(() => {
    if (load) {
      fetchData();
    }
  }, [load, page, rowsPerPage, searchQuery]);

  const handleSearchChange = (e) => setSearchInput(e.target.value);

  const handleSearch = () => {
    setSearchQuery(searchInput); // update actual query
    setPage(0);
    setLoad(true); // trigger fetch
  };

  const handleClearSearch = () => {
    setSearchInput('');
    setSearchQuery('');
    setPage(0);
    setLoad(true);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <PaginationTable
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      count={count}
      error={networkError}
      loading={loading}
      setLoading={setLoading}
      setLoad={setLoad}
      rows={rows}
      columns={columns}
      calculatedHeight={288}
      tableFilter={
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search by domain"
          value={searchInput}
          onChange={handleSearchChange}
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchInput && (
                  <IconButton size="small" onClick={handleClearSearch}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
                <IconButton size="small" onClick={handleSearch}>
                  <SearchIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ width: 300 }}
        />
      }
    />
  );
};
